var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCny = function SvgCny(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2H16V14H0V2Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55692 6.87765L1.61027 8.40337L2.3536 6.09606L1.05542 4.8963L2.81322 4.83143L3.55692 2.97421L4.30061 4.83143H6.05542L4.76023 6.09606L5.35025 8.40337L3.55692 6.87765Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50817 5.08594L6.69131 5.57908L6.87763 4.61677L6.19739 3.89658L7.11848 3.85763L7.50817 2.95908L7.89787 3.85763H8.81739L8.13871 4.61677L8.34303 5.57908L7.50817 5.08594Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50817 7.08594L7.69131 7.57908L7.87763 6.61677L7.19739 5.89658L8.11848 5.85763L8.50817 4.95908L8.89787 5.85763H9.81739L9.13871 6.61677L9.34303 7.57908L8.50817 7.08594Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50817 9.08594L6.69131 9.57908L6.87763 8.61677L6.19739 7.89658L7.11848 7.85763L7.50817 6.95908L7.89787 7.85763H8.81739L8.13871 8.61677L8.34303 9.57908L7.50817 9.08594Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50817 10.0859L4.69131 10.5791L4.87763 9.61677L4.19739 8.89658L5.11848 8.85763L5.50817 7.95908L5.89787 8.85763H6.81739L6.13871 9.61677L6.34303 10.5791L5.50817 10.0859Z",
    fill: "#FECA00"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCny);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "CNY.158113f6cdc0398694a3750106ef8922.svg";